import * as Styled from '../../Forms/Forms.styles'

import { SubmitHandler, useForm } from 'react-hook-form'

import AddToProjectToast from '../AddToProjectToast/AddToProjectToast'
import { addTracksToProject } from '../../../../services/projectsService'
import { sendAnalytics } from '@audio-network/analytics'
import { toast } from 'react-toastify'
import { useTranslation } from 'next-i18next'

type Props = {
	onClose: () => void
	tracks: Track[]
	projects: Project[]
	source: string
}

type ExistingProjectFormData = {
	projectOption: string
}

export default function AddToProjectsExistingForm({
	onClose,
	tracks,
	projects,
	source,
}: Props): JSX.Element {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<ExistingProjectFormData>({ mode: 'onChange' })

	const { t } = useTranslation(['addtoproject'])

	const handleExistingProjectSubmit: SubmitHandler<
		ExistingProjectFormData
	> = async (data): Promise<void> => {
		const response = await addTracksToProject(
			data.projectOption,
			tracks.map((track) => track.id)
		)
		toast.dismiss()
		if (!response) {
			toast.error(<AddToProjectToast error />)
		} else {
			const selectedProject = projects.find(
				({ Id }) => Id === data.projectOption
			)
			toast.success(
				<AddToProjectToast tracks={tracks} projectName={selectedProject.Name} />
			)

			let analyticsOptions = {}
			if (tracks.length === 1) {
				analyticsOptions = {
					Existing: true,
					TrackId: tracks[0].id,
					TrackTitle: tracks[0].title,
					AlbumNo: tracks[0].album.number,
					TrackSource: source,
					Catalogue: tracks[0].album.catalogue.name,
					Genre: tracks[0].album.genre,
				}
			} else {
				analyticsOptions = {
					Existing: true,
					TrackCount: tracks.length,
					TrackSource: source,
				}
			}

			sendAnalytics({
				noun: 'Add to Project',
				pastTenseVerb: 'Completed',
				eventParameters: analyticsOptions,
			})
		}
		onClose()
	}

	const selectId = `add-${tracks
		.map((track) => track.id)
		.join('-')}-to-existing-project`

	return (
		<>
			{projects && (
				<Styled.Form
					noValidate
					onSubmit={handleSubmit(handleExistingProjectSubmit)}
				>
					<Styled.FieldLabel htmlFor={selectId}>
						{t('add-to-existing-project.project-field')}
					</Styled.FieldLabel>
					<Styled.FieldWrap hasError={errors.projectOption}>
						<Styled.FieldSelect id={selectId} {...register('projectOption')}>
							{projects?.map((project) => {
								return (
									<option key={project.Id} value={project.Id}>
										{project.Name.length > 45
											? project.Name.slice(0, 45) + '...'
											: project.Name}
									</option>
								)
							})}
						</Styled.FieldSelect>
						<Styled.FieldChevronDown />
					</Styled.FieldWrap>
					<Styled.ButtonWrapper>
						<Styled.SubmitButton type="submit" data-testid="accept-add">
							{t('add-to-existing-project.submit-form')}
						</Styled.SubmitButton>
					</Styled.ButtonWrapper>
				</Styled.Form>
			)}
		</>
	)
}
